<!--========================================
=            ANALYTIC SPARKLINE            =
=========================================-->
<template>
  <v-layout
    class="ma-1"
    :column="$vuetify.breakpoint.smAndDown"
    :row="!$vuetify.breakpoint.smAndDown"
  >
    <v-flex xs12 sm12 md4 pa-3>
      <v-card class="card ma-1" :dark="appConfig.dark">
        <div>
          <div class="chart-gutters" id="spark1"></div>
        </div>
      </v-card>
    </v-flex>
    <v-flex xs12 sm12 md4 pa-3>
      <v-card class="card ma-1" :dark="appConfig.dark">
        <div>
          <div class="chart-gutters" id="spark2"></div>
        </div>
      </v-card>
    </v-flex>
    <v-flex xs12 sm12 md4 pa-3>
      <v-card class="card ma-1" :dark="appConfig.dark">
        <div>
          <div id="spark3" class="chart-gutters"></div>
        </div>
      </v-card>
    </v-flex>
  </v-layout>
</template>
<script>
export default {
  mounted() {
    window.Apex = {
      stroke: {
        width: 3
      },
      markers: {
        size: 0
      },
      tooltip: {
        fixed: {
          enabled: false
        }
      }
    };

    var randomizeArray = function(arg) {
      var array = arg.slice();
      var currentIndex = array.length,
        temporaryValue,
        randomIndex;

      while (0 !== currentIndex) {
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;

        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
      }

      return array;
    };

    // data for the sparklines that appear below header area
    var sparklineData = [
      47,
      45,
      54,
      38,
      56,
      24,
      65,
      31,
      37,
      39,
      62,
      51,
      35,
      41,
      35,
      27,
      93,
      53,
      61,
      27,
      54,
      43,
      19,
      46
    ];

    var spark1 = {
      chart: {
        type: "area",
        height: 160,
        width: 320,

        sparkline: {
          enabled: true
        }
      },
      stroke: {
        curve: "straight"
      },
      fill: {
        opacity: 0.9
      },
      series: [
        {
          data: randomizeArray(sparklineData)
        }
      ],
      yaxis: {
        min: 0
      },
      colors: ["#7f59c2"],
      title: {
        text: "$424,652",
        offsetX: 0,
        style: {
          color: "#7f59c2",
          fontSize: "20px",
          cssClass: "apexcharts-yaxis-title"
        }
      },
      subtitle: {
        color: "#7f59c2",
        text: "Sales",
        offsetX: 0,
        style: {
          color: "#7f59c2",
          fontSize: "14px",
          cssClass: "apexcharts-yaxis-title"
        }
      }
    };

    var spark2 = {
      chart: {
        type: "area",
        height: 160,
        width: 320,
        sparkline: {
          enabled: true
        }
      },
      stroke: {
        curve: "straight"
      },
      fill: {
        opacity: 0.3
      },
      series: [
        {
          data: randomizeArray(sparklineData)
        }
      ],
      yaxis: {
        min: 0
      },
      colors: ["#7B1FA2"],
      title: {
        text: "$235,312",
        offsetX: 0,
        style: {
          color: "#7B1FA2",
          fontSize: "20px",
          cssClass: "apexcharts-yaxis-title"
        }
      },
      subtitle: {
        text: "Expenses",
        offsetX: 0,
        style: {
          color: "#7B1FA2",
          fontSize: "14px",
          cssClass: "apexcharts-yaxis-title"
        }
      }
    };

    var spark3 = {
      chart: {
        type: "area",
        height: 160,
        width: 320,
        sparkline: {
          enabled: true
        }
      },
      stroke: {
        curve: "straight"
      },
      fill: {
        opacity: 0.3
      },
      series: [
        {
          data: randomizeArray(sparklineData)
        }
      ],
      colors: ["#AD1457"],
      xaxis: {
        crosshairs: {
          width: 1
        }
      },
      yaxis: {
        min: 0
      },
      title: {
        text: "$135,965",
        offsetX: 0,
        style: {
          color: "#AD1457",
          fontSize: "20px",
          cssClass: "apexcharts-yaxis-title"
        }
      },
      subtitle: {
        text: "Profits",
        offsetX: 0,
        style: {
          color: "#AD1457",
          fontSize: "14px",
          cssClass: "apexcharts-yaxis-title"
        }
      }
    };
    // eslint-disable-next-line no-undef
    // eslint-disable-next-line no-redeclare
    var spark1 = new ApexCharts(document.querySelector("#spark1"), spark1);
    spark1.render(); // eslint-disable-next-line no-undef
    // eslint-disable-next-line no-redeclare
    var spark2 = new ApexCharts(document.querySelector("#spark2"), spark2);
    spark2.render();
    // eslint-disable-next-line no-undef
    // eslint-disable-next-line no-redeclare
    var spark3 = new ApexCharts(document.querySelector("#spark3"), spark3);
    spark3.render();
  },
  data() {
    return {};
  },
  methods: {}
};
</script>

<style>
.shadow {
  box-shadow: 0px 0px 13px 0px rgba(82, 63, 105, 0.05) !important;
}
</style>

<!--====  End of ANALYTIC SPARKLINE  ====-->